module.exports = __webpack_public_path__ + "static/media/affiliates-icon.97f723a9.svg";